// extracted by mini-css-extract-plugin
module.exports = {"container":"_3QzEHuUcJwS0VxWRwKvs57","cancelBtn":"_1-ysPyTjpK4QCETwTjsVUR","icon":"FsRWZYT18JzVCGcUR2p4l","saveBtn":"_27fhEmVsgpNmrbvSPGlInY"};